import React from 'react';

import { Box } from '../abstract';

export const BarWrapper = ({ children, ...props }) => (
  <Box bg="primaries.Soul" fontSize={{ sm: 1, md: 2 }} {...props}>
    {children}
  </Box>
);
